import {
  defaultLaunchQueryParams,
  launchQueryParamsSchema,
} from "@/pages/launch/schemata";
import { LaunchPageAdapter } from "@/pages/LaunchPageAdapter";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/apps/$appId/launch/$renderMode/$targetDeviceType",
)({
  component: LaunchPageAdapter,
  validateSearch: launchQueryParamsSchema,
  search: {
    // strip default values
    middlewares: [stripSearchParams(defaultLaunchQueryParams)],
  },
});
